/**
 * @file graphql/airport.graphql.ts
 * queries/mutations for airports.
 *
 */

import { gql } from "@apollo/client";

export const LOAD_AIRPORTS_QUERY = gql`
  query Airports($globalSearch: String, $iataCode: String) {
    airports(globalSearch: $globalSearch, iataCode: $iataCode) {
      edges {
        node {
          icaoCode
          iataCode
          airportName
          countryName
          countryIso2
          timezone
          gmt
          coordinates
        }
      }
    }
  }
`;
